// Error codes injected by Auth0 Actions as a suffix in error_description: [CODE]
// e.g. "Please verify your email address before logging in. [ERR_EMAIL_UNVERIFIED]"
// The frontend strips the code from any displayed message so users never see it.
export const AUTH_ERROR_CODES = {
  ERR_EMAIL_UNVERIFIED: 'ERR_EMAIL_UNVERIFIED'
} as const

export type AuthErrorCode = keyof typeof AUTH_ERROR_CODES

const CODE_PATTERN = /\s*\[([A-Z0-9_]+)\]\s*$/

/** Extracts the embedded error code and returns a clean display message. */
export function parseAuthError(message: string): {
  code: AuthErrorCode | null
  displayMessage: string
} {
  const match = message.match(CODE_PATTERN)
  const raw = match?.[1] ?? null
  const code = raw && raw in AUTH_ERROR_CODES ? (raw as AuthErrorCode) : null
  const displayMessage = message.replace(CODE_PATTERN, '').trim()
  return { code, displayMessage }
}
